import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-distribution-scale",
  "use": "foquz-icon-question-distribution-scale-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" fill=\"none\" id=\"foquz-icon-question-distribution-scale\"><path d=\"M7 13a2 2 0 104 0 2 2 0 00-4 0zm0 0H4m9 7a2 2 0 104 0 2 2 0 00-4 0zm0 0H4m8-14a2 2 0 104 0 2 2 0 00-4 0zm0 0H4\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /><path d=\"M21.5 20h.01M21.5 6h.01m0 7h-.01\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol